import * as CONSTANTS from './constants'

const initialState = {
  currentSync: 1,
  // Informações de progresso detalhadas (opcional)
  progress: {
    attempt: 0,
    maxAttempts: 0,
    entity: null,
    recordsProcessed: 0,
    totalRecords: 0,
    startTime: null,
  }
}

// P08 FIX: Estados finais que devem resetar o progress
const FINAL_STATES = [
  CONSTANTS.SYNC_STATUS?.ERROR,    // 0
  CONSTANTS.SYNC_STATUS?.SUCCESS,  // 2
  0,  // Fallback para ERROR
  2,  // Fallback para SUCCESS
]

export default function reduce(state = initialState, action) {
  switch (action.type) {
    case CONSTANTS.CHANGE_CURRENT_SYNC_VIEW:
      // P08 FIX: Resetar progress quando sync termina (success ou error)
      const shouldResetProgress = FINAL_STATES.includes(action.payload)
      return {
        ...state,
        currentSync: action.payload,
        // Resetar progress em estados finais para não mostrar dados stale
        progress: shouldResetProgress ? initialState.progress : state.progress
      }
    case CONSTANTS.UPDATE_SYNC_PROGRESS:
      return {
        ...state,
        progress: {
          ...state.progress,
          ...action.payload
        }
      }
    default:
      return state
  }
}
